/**
 * 從側欄以外的地方打開設定視窗（AGUI-1113）。
 *
 * 設定視窗的狀態在 Sidebar 裡，各頁面與 Sidebar 是兄弟元件；
 * 用 window 事件而不是把 setter 一路傳下去，頁面才不必知道 Sidebar 的內部狀態。
 *
 * - {@link openSettings}：請 Sidebar 開啟設定視窗並切到指定分頁
 * - {@link SETTINGS_CLOSED_EVENT}：設定視窗關閉時由 Sidebar 發出，
 *   頁面據此重查狀態（例如使用者剛在「第三方服務」連好 Outlook）
 */
export const OPEN_SETTINGS_EVENT = 'mygenie:open-settings';
export const SETTINGS_CLOSED_EVENT = 'mygenie:settings-closed';

/** @param {'general'|'connector'} [tab] */
export const openSettings = (tab = 'general') => {
  window.dispatchEvent(new CustomEvent(OPEN_SETTINGS_EVENT, { detail: { tab } }));
};
